import React, {memo, ReactNode, useCallback} from 'react';
import {ControlModel, ControlTypeModel, ThreePhaseSet} from '../../types/control';
import {useRPC} from '../../hooks/rpc';
import {ThreePhaseControlComponent} from './component';
import {useDispatch} from 'react-redux';
import {useDebounce} from '../../hooks/debounce';
import {entityUpdatedAction} from '../../store/control/actions';

export enum PhaseStatus {
    Stop,
    Up,
    Down
}

type Props = {
    control: ControlModel;
    controlType: ControlTypeModel<ThreePhaseSet>;
    children?: ReactNode;
};

export const ThreePhaseControl = memo(function CurtainControl(props: Props) {
    const {control, children, ...restProps} = props;

    const [rpc] = useRPC();
    const updateControl = useDebounce(rpc.updateControlValue, 200);

    const dispatch = useDispatch();
    const click = useCallback((status: PhaseStatus) => {
        dispatch(entityUpdatedAction({...control, isUpdating: true}, 'control'));
        updateControl(control.id, status);
    }, [control, updateControl, dispatch]);

    return (
        <ThreePhaseControlComponent control={control} click={click} {...restProps}>
            {children}
        </ThreePhaseControlComponent>
    );
});
